import PhoneInput from './PhoneInput';
import flagsStyles from './flags.module.scss';
import phoneInputStyles from './phoneInput.module.scss';

export { PhoneInput, flagsStyles, phoneInputStyles };

export default PhoneInput;
